"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.form.knowledge.show': 'Pokaż wpisy wiedzy',
    'avatar.form.knowledge.label': 'Wpisy Bazy Wiedzy',
    'avatar.form.knowledge.search_placeholder': 'Szukaj wpisów wiedzy...',
    'avatar.form.knowledge.add': 'Dodaj Nową Wiedzę',
    'avatar.form.knowledge.fullscan': 'Pełne skanowanie dokumentu',
    'avatar.form.title.edit': 'Edytuj Awatar',
    'avatar.form.title.add': 'Dodaj Awatar',
    'avatar.form.back': 'Wstecz',
    'avatar.form.name.label': 'Nazwa',
    'avatar.form.name.placeholder': 'Nazwa awatara',
    'avatar.form.gender.label': 'Płeć',
    'avatar.form.gender.placeholder': 'Wybierz płeć',
    'avatar.form.gender.none': 'Brak',
    'avatar.form.gender.male': 'Mężczyzna',
    'avatar.form.gender.female': 'Kobieta',
    'avatar.form.age.label': 'Wiek',
    'avatar.form.age.placeholder': 'Wiek',
    'avatar.form.voice.label': 'Głos',
    'avatar.form.voice.placeholder': '-- Wybierz Głos --',
    'avatar.form.voice.male': 'Głosy Męskie',
    'avatar.form.voice.female': 'Głosy Kobiece',
    'avatar.form.logo.label': 'Obraz awatara',
    'avatar.form.logo.placeholder': 'Wyślij obraz awatara',
    'avatar.form.instructionFile.label': 'Plik Instrukcji',
    'avatar.form.instructionFile.placeholder': 'Prześlij plik instrukcji',
    'avatar.form.instructions.title': 'Instrukcje',
    'avatar.form.instructions.description': 'Zarządzaj wpisami instrukcji, które kierują zachowaniem awatara. Każdy wpis wymaga załączonego pliku i może również mieć notatki oraz prompt.',
    'avatar.form.error.instruction_file_required': 'Każdy wpis instrukcji musi mieć załączony plik.',
    'avatar.form.instructions.add': 'Dodaj instrukcję',
    'avatar.form.instructions.empty': 'Brak wpisów instrukcji. Kliknij "Dodaj instrukcję", aby utworzyć nowy.',
    'avatar.form.instructions.untitled': 'Warstwa bez nazwy',
    'avatar.form.instructions.layer.label': 'Warstwa',
    'avatar.form.instructions.layer.placeholder': 'Wprowadź nazwę warstwy',
    'avatar.form.instructions.notes.label': 'Notatki',
    'avatar.form.instructions.notes.placeholder': 'Wprowadź notatki do instrukcji',
    'avatar.form.instructions.prompt.label': 'Prompt instrukcji',
    'avatar.form.instructions.prompt.placeholder': 'Wprowadź prompt instrukcji',
    'avatar.form.instructions.file.label': 'Plik instrukcji',
    'avatar.form.instructions.isPublic.label': 'Publiczna (wysyłana w webhookach)',
    'avatar.form.instructions.file.placeholder': 'Prześlij plik instrukcji',
    'avatar.form.instructions.files.label': 'Pliki instrukcji',
    'avatar.form.instructions.files.placeholder': 'Prześlij pliki instrukcji',
    'avatar.form.instructions.versions.title': 'Historia wersji',
    'avatar.form.instructions.versions.show': 'Pokaż historię wersji',
    'avatar.form.instructions.versions.hide': 'Ukryj historię wersji',
    'avatar.form.instructions.versions.empty': 'Brak wcześniejszych wersji.',
    'avatar.form.instructions.versions.restore': 'Przywróć',
    'avatar.form.instructions.versions.restore_confirm': 'Czy na pewno chcesz przywrócić tę wersję? Bieżące zmiany zostaną nadpisane.',
    'avatar.form.description.label': 'Opis',
    'avatar.form.description.placeholder': 'Opis',
    'avatar.form.model.label': 'Model',
    'avatar.form.model.placeholder': 'Wybierz model',
    'avatar.form.knowledge.placeholder': 'Wybierz wpisy wiedzy',
    'avatar.form.submit.update': 'Zaktualizuj Awatar',
    'avatar.form.submit.create': 'Utwórz Awatar',
    'avatar.form.submit.saveAndReturn.update': 'Zapisz Awatar i wróć do listy',
    'avatar.form.submit.saveAndReturn.create': 'Utwórz Awatar i wróć do listy',
    'avatar.form.tab.configuration': 'Konfiguracja',
    'avatar.form.tab.knowledge': 'Baza Wiedzy',
    'avatar.form.tab.instructions': 'Instrukcje',
    'avatar.form.tab.tools': 'Narzędzia',
    'avatar.form.tab.webhooks': 'Webhooki',
    'avatar.form.tab.lexicon': 'Leksykon',
    'avatar.form.tab.rag': 'Ustawienia RAG',
    'avatar.form.tab.apiTools': 'Narzędzia API',
    'avatar.form.timed.label': 'Włącz dostępność czasową',
    'avatar.form.timed.help': 'Ogranicz kiedy ten awatar jest dostępny',
    'avatar.form.startTime.label': 'Dostępny od',
    'avatar.form.startTime.placeholder': 'Wybierz datę rozpoczęcia',
    'avatar.form.endTime.label': 'Dostępny do',
    'avatar.form.endTime.placeholder': 'Wybierz datę zakończenia',
    'avatar.form.webhooks.config.title': 'Konfiguracja Webhooków',
    'avatar.form.webhooks.config.description': 'Skonfiguruj ustawienia autoryzacji dla wszystkich punktów końcowych webhooków',
    'avatar.form.webhooks.config.authHeader.label': 'Nagłówek Autoryzacji',
    'avatar.form.webhooks.config.authHeader.placeholder': 'np. Authorization',
    'avatar.form.webhooks.config.authKey.label': 'Klucz Autoryzacji',
    'avatar.form.webhooks.config.authKey.placeholder': 'Token Bearer lub klucz API',
    'avatar.form.webhooks.definitions.title': 'Definicje Webhooków',
    'avatar.form.webhooks.definitions.add': 'Dodaj Webhook',
    'avatar.form.webhooks.definitions.empty': 'Brak skonfigurowanych definicji webhooków. Kliknij "Dodaj Webhook" aby utworzyć jedną.',
    'avatar.form.webhooks.definitions.untitled': 'Webhook Bez Nazwy',
    'avatar.form.webhooks.definitions.name.label': 'Nazwa Webhooka',
    'avatar.form.webhooks.definitions.name.placeholder': 'Wprowadź nazwę webhooka',
    'avatar.form.webhooks.definitions.address.label': 'URL Webhooka',
    'avatar.form.webhooks.definitions.address.placeholder': 'https://twoj-endpoint.com/webhook',
    'avatar.form.webhooks.definitions.eventType.label': 'Typ Zdarzenia',
    'avatar.form.webhooks.definitions.cronInterval.label': 'Interwał Cron',
    'avatar.form.webhooks.definitions.cronInterval.placeholder': '*/30 * * * *',
    'avatar.form.webhooks.definitions.cronInterval.help': 'Wyrażenie cron (np. */30 * * * * = co 30 minut)',
    'avatar.form.webhooks.definitions.cronEnabled.label': 'Włącz Cron',
    'avatar.form.webhooks.definitions.active.label': 'Aktywny',
    'avatar.form.webhooks.definitions.authEnabled.label': 'Włącz Autoryzację',
    'avatar.form.webhooks.definitions.authHeader.label': 'Nagłówek Autoryzacji',
    'avatar.form.webhooks.definitions.authHeader.placeholder': 'np. Authorization',
    'avatar.form.webhooks.definitions.authKey.label': 'Klucz Autoryzacji',
    'avatar.form.webhooks.definitions.authKey.placeholder': 'Token Bearer lub klucz API',
    'avatar.form.webhooks.payload.title': 'Przykład ładunku',
    'avatar.form.webhooks.payload.subtitle': 'Przykładowy ładunek JSON dla tego typu zdarzenia webhook',
    'avatar.form.webhooks.payload.description': 'To jest struktura danych JSON, które będą wysyłane do Twojego endpointu webhook.',
    'avatar.form.lexicon.title': 'Wpisy Leksykonu',
    'avatar.form.lexicon.add': 'Dodaj Wpis',
    'avatar.form.lexicon.empty': 'Nie skonfigurowano wpisów leksykonu. Kliknij "Dodaj Wpis" aby utworzyć.',
    'avatar.form.lexicon.untitled': 'Wpis Bez Tytułu',
    'avatar.form.lexicon.hidden': 'Ukryty',
    'avatar.form.lexicon.label.label': 'Etykieta',
    'avatar.form.lexicon.label.placeholder': 'Wprowadź termin lub słowo',
    'avatar.form.lexicon.value.label': 'Definicja',
    'avatar.form.lexicon.value.placeholder': 'Wprowadź definicję lub wyjaśnienie',
    'avatar.form.lexicon.hidden.label': 'Ukryty',
    'avatar.form.lexicon.hidden.help': 'Gdy włączone, ten wpis nie będzie widoczny dla użytkowników, ale będzie używany przez awatara do zrozumienia',
    'avatar.form.apiTools.title': 'Narzędzia API',
    'avatar.form.apiTools.description': 'Skonfiguruj zewnętrzne punkty końcowe API, które AI może wywoływać podczas rozmów',
    'avatar.form.apiTools.enabled.label': 'Włącz narzędzia API',
    'avatar.form.apiTools.enabled.help': 'Pozwól awatarowi na wykonywanie wywołań do zewnętrznych punktów końcowych API',
    'avatar.form.apiTools.list.title': 'Punkty końcowe API',
    'avatar.form.apiTools.add': 'Dodaj punkt końcowy',
    'avatar.form.apiTools.empty': 'Brak skonfigurowanych punktów końcowych API. Kliknij "Dodaj punkt końcowy", aby utworzyć.',
    'avatar.form.apiTools.untitled': 'Bez nazwy',
    'avatar.form.apiTools.name.label': 'Nazwa',
    'avatar.form.apiTools.name.placeholder': 'Wprowadź nazwę punktu końcowego',
    'avatar.form.apiTools.endpoint.label': 'URL punktu końcowego',
    'avatar.form.apiTools.endpoint.placeholder': 'https://api.example.com/endpoint',
    'avatar.form.apiTools.method.label': 'Metoda',
    'avatar.form.apiTools.description.label': 'Opis',
    'avatar.form.apiTools.description.placeholder': 'Opisz co robi ten punkt końcowy API',
    'avatar.form.apiTools.description.help': 'Opis pomaga AI zrozumieć kiedy i jak używać tego punktu końcowego',
    'avatar.form.apiTools.authEnabled.label': 'Włącz autoryzację',
    'avatar.form.apiTools.authHeader.label': 'Nagłówek autoryzacji',
    'avatar.form.apiTools.authHeader.placeholder': 'np. Authorization',
    'avatar.form.apiTools.authKey.label': 'Klucz autoryzacji',
    'avatar.form.apiTools.authKey.placeholder': 'Token Bearer lub klucz API',
    'avatar.form.apiTools.authKey.toggle': 'Pokaż/Ukryj klucz',
    'avatar.form.apiTools.payloadFields.title': 'Pola danych',
    'avatar.form.apiTools.payloadFields.add': 'Dodaj pole',
    'avatar.form.apiTools.payloadFields.description': 'Zdefiniuj pola, które AI wypełni podczas wywoływania tego punktu końcowego',
    'avatar.form.apiTools.payloadFields.empty': 'Brak zdefiniowanych pól danych. Kliknij "Dodaj pole", aby utworzyć.',
    'avatar.form.apiTools.payloadFields.name.label': 'Nazwa pola',
    'avatar.form.apiTools.payloadFields.name.placeholder': 'np. query',
    'avatar.form.apiTools.payloadFields.desc.label': 'Opis pola',
    'avatar.form.apiTools.payloadFields.desc.placeholder': 'Opisz do czego służy to pole, aby AI wiedziało jak je wypełnić',
    'avatar.form.apiTools.payloadFields.type.label': 'Typ',
    'avatar.form.apiTools.payloadFields.optional.label': 'Opcjonalne',
    'avatar.form.tools.title': 'Dostępne Narzędzia',
    'avatar.form.tools.description': 'Wybierz które narzędzia ten awatar może używać podczas rozmów',
    'avatar.form.error.load_failed': 'Błąd ładowania awatara',
    'avatar.form.error.model_required': 'Model jest wymagany',
    'avatar.form.error.action_failed': 'Akcja nieudana',
    'avatar.form.error.general_error': 'Wystąpił błąd',
    'avatar.form.action.updated': 'zaktualizowany',
    'avatar.form.action.created': 'utworzony',
    'avatar.form.action.update': 'zaktualizuj',
    'avatar.form.action.create': 'utwórz',
    'avatar.form.success.updated': 'Awatar pomyślnie zaktualizowany',
    'avatar.form.success.action_completed': 'Akcja awatara pomyślnie zakończona',
    'avatar.form.rag.settings.title': 'Ustawienia wyszukiwania RAG',
    'avatar.form.rag.settings.description': 'Skonfiguruj parametry wyszukiwania RAG dla tego awatara. Te ustawienia nadpisują globalne wartości domyślne.',
    'avatar.form.rag.settings.note.title': 'Uwaga:',
    'avatar.form.rag.settings.note.description': 'Te ustawienia wpływają tylko na zachowanie wyszukiwania wiedzy tego awatara. Zmiany obowiązują natychmiast.',
};
